import useAxios from 'hooks/useAxios'
import * as R from 'ramda'
import constants from 'config/constants'
import store from 'store'
import dayjs from 'dayjs'

export default function usePermission() {
  // required fetch user data on DashboardRoutes
  const timezone = dayjs.tz.guess()

  const { data: user } = useAxios({
    url: `account/users/me/v2/?timezone=${encodeURIComponent(timezone)}`,
    key: store.get(constants.simplesatWorkspaceTokenName),
  })

  function getRole() {
    return R.prop('role', user)
  }

  function hasPermission(permission) {
    const permissions = R.prop('account_role_permissions', user) || {}

    return R.prop(permission, permissions) === true
  }

  return {
    user: user,
    role: getRole(),
    hasPermission: hasPermission,
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/usePermission/index.js